import * as yup from "yup";

export const invoiceCostPriceSchema = yup.object().shape({
  inventoryItemId: yup.string().transform((value) => value ?? ""),
  cost: yup.number().label("Cost"),
  price: yup.number().label("Price"),
});
